'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REGISTER_FORM_FIELDS = exports.REGISTER_FORM_NAME = undefined;

var _validationConstants = require('../../../../common/validation/validationConstants');

var REGISTER_FORM_NAME = exports.REGISTER_FORM_NAME = 'register'; // Constants
var REGISTER_FORM_FIELDS = exports.REGISTER_FORM_FIELDS = _validationConstants.REGISTER_FIELDS;


//////////////////
// WEBPACK FOOTER
// ./src/client/auth/modals/register/registerFormConstants.js
// module id = 292
// module chunks = 0